import { useCallback } from "react";
import Cookies from "js-cookie";

import {
  API_AUTH_GENERATE_OTP,
  API_VALIDATE_TOKEN,
} from "../../../../../config/Endpoints.js";
import { postApi, ZOD_PARSE_ERROR } from "../../../../utils/api.ts";
import {
  generateOtpResponseSchema,
  type GenerateOtpResponse,
} from "../schemas/onboard-verify.schema.ts";
import { useSqeOnboardingApi } from "../../onboarding/sqe/sqe-onboarding-link-context.tsx";
import { SQE_ONBOARDING, unwrapSqeData } from "../../onboarding/sqe/sqe-onboarding-api.ts";

export function usePrejoinOtp() {
  const isSqe = useSqeOnboardingApi();
  const generateOtp = useCallback(
    async (token: string, email: string): Promise<GenerateOtpResponse> => {
      const url = `${isSqe ? `${SQE_ONBOARDING}/generate-otp` : API_AUTH_GENERATE_OTP}?token=${encodeURIComponent(token)}&email=${encodeURIComponent(email)}`;
      const accessToken = isSqe ? undefined : Cookies.get("accessToken");
      const { data } = await postApi<unknown>(url, accessToken, {});
      const parsed = generateOtpResponseSchema.safeParse(isSqe ? unwrapSqeData(data) : data);
      if (!parsed.success) {
        throw new Error(ZOD_PARSE_ERROR);
      }
      return parsed.data;
    },
    [isSqe],
  );

  const validateOtp = useCallback(
    async (token: string, email: string, otp: string): Promise<unknown> => {
      const url = isSqe
        ? `${SQE_ONBOARDING}/validate?token=${encodeURIComponent(token)}&email=${encodeURIComponent(email)}&otp=${encodeURIComponent(otp)}`
        : `${API_VALIDATE_TOKEN}?Token=${encodeURIComponent(token)}&email=${encodeURIComponent(email)}&otp=${encodeURIComponent(otp)}`;
      const accessToken = isSqe ? undefined : Cookies.get("accessToken");
      const { data } = await postApi<unknown>(url, accessToken, {});
      return isSqe ? unwrapSqeData(data) : data;
    },
    [isSqe],
  );

  return { generateOtp, validateOtp };
}
